import { Fragment } from "react";

export interface FactTableRow {
  key: string;
  label: string;
  value: string;
}

/**
 * Label/value table of the product detail page ("차량 정보", "핵심 정보").
 * A `<dl>` laid out as a grid: mobile 1 pair per row, desktop 2 pairs.
 *
 * 라벨 열은 max-content 로 가장 긴 라벨에 맞춰 잡는다(줄바꿈·잘림 없음).
 * 셀을 평평하게 깔아야 모든 행이 같은 라벨 열을 공유한다 — 행마다 그리드를
 * 따로 만들면 라벨 폭이 행마다 달라진다. 데스크톱은 4열(라벨·값 ×2).
 */
export default function FactTable({ rows }: { rows: readonly FactTableRow[] }) {
  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      <dl className="-mb-px grid grid-cols-[max-content_minmax(0,1fr)] md:grid-cols-[max-content_minmax(0,1fr)_max-content_minmax(0,1fr)] md:[&>*:nth-child(4n+3)]:border-l md:[&>*:nth-child(4n+3)]:border-l-gray-200">
        {rows.map((row) => (
          <Fragment key={row.key}>
            <dt className="bg-gray-50 px-4 py-3 text-sm text-gray-500 whitespace-nowrap border-b border-gray-200">
              {row.label}
            </dt>
            <dd className="px-4 py-3 text-sm text-gray-900 wrap-break-word border-b border-gray-200">
              {row.value}
            </dd>
          </Fragment>
        ))}
      </dl>
    </div>
  );
}
